import {
  styled,
  MenuItem as MuiMenuItem,
  Menu as MuiMenu,
} from "@mui/material";
import MuiBox from "@mui/material/Box";

export const LoadingContainer = styled(MuiBox)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  margin: "0 auto",
}));

export const Menu = styled(MuiMenu)(() => ({
  "[role='menu']": {
    backgroundColor: "var(--color-header-profile-menu-background) !important",
    border: "var(--color-header-profile-menu-border) !important",
  },
}));

export const MenuItem = styled(MuiMenuItem)(() => ({
  backgroundColor:
    "var(--color-header-profile-menu-item-background) !important",
  color: "var(--color-header-profile-menu-item-text) !important",
  "&:hover": {
    backgroundColor:
      "var(--color-header-profile-menu-item-background-hover) !important",
  },
}));
